import axios, { Method, ResponseType } from 'axios'
import { keysToCamelCase } from '@src/lib/utils'
import { store } from '@src/store/store'
import { logout } from '@src/store/ducks/auth/thunks'

type CallApiType = {
  url: string
  data?: object
  params?: object
  headers?: object
  responseType?: ResponseType
  method: Method
}
const getNewToken = async () => {
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/refresh`, {})
    return true
  } catch (err: any) {
    if (err?.response?.status === 401) {
      store.dispatch(logout(true))
    }
    return Promise.reject(err)
  }
}
const callApi = async ({
  url, method, data, params = {}, headers = {}, responseType,
}:CallApiType) => {
  const token = `Bearer ${localStorage.getItem('Authorization')}`
  const config = {
    url,
    method,
    params,
    data,
    responseType,
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: {
      ...axios.defaults.headers.common,
      'Content-Type': 'application/json',
      Authorization: token,
      ...headers,
    },
  }
  try {
    const response = await axios(config)
    return keysToCamelCase(response.data)
  } catch (err: any) {
    // @ts-ignore
    if (err?.response?.status === 401) {
      await getNewToken()
      return new Promise((resolve, reject) => {
        axios.request(err.config).then((response) => {
          resolve(keysToCamelCase(response.data))
        }).catch((error) => {
          if (err?.response?.status === 401) {
            store.dispatch(logout(true))
          }
          reject(error)
        })
      })
      // todo добавить логаут при 401
    }
    return Promise.reject(err)
  }
}

export const api = {
  async get<T = any>(url: string, params?: object, headers?: object, responseType?: ResponseType): Promise<T> {
    return callApi({
      url, params, headers, responseType, method: 'GET',
    })
  },
  async post<T = any>(url: string, data?: object, params?: object, headers?: object): Promise<T> {
    return callApi({
      url, data, params, headers, method: 'POST',
    })
  },
  async put<T = any>(url: string, data?: object, params?: object, headers?: object): Promise<T> {
    return callApi({
      url, data, params, headers, method: 'PUT',
    })
  },
  async del<T = any>(url: string, params?: object, headers?: object): Promise<T> {
    return callApi({
      url, params, headers, method: 'DELETE',
    })
  },
}
